import { useSelector } from 'react-redux';
import { findCountryWithAgencyConfigForUser } from 'features/auth/helpers';
import { CountryCodeEnum } from 'features/common/types';
import { RootState } from 'store';
import { useServiceQuickEdit } from '../context/ServiceQuickEditContext';

/** País de mercado del servicio: BU del quick edit si aplica, si no el contexto del header. */
export const useServiceMarketCountry = (): CountryCodeEnum => {
	const { auth } = useSelector((state: RootState) => state);
	const quickEdit = useServiceQuickEdit();

	if (quickEdit?.agencyId) {
		const agencyConfig = findCountryWithAgencyConfigForUser(quickEdit.agencyId);
		if (agencyConfig?.id) {
			return agencyConfig.id;
		}
	}

	return auth.country;
};
